import React from 'react';
import pt from 'prop-types';
import {getHelmetForMetaTags} from '../../utils/epicGamesUtils';
import {useLoading, useNotFound} from '../../utils/loadingUtils';
import Error404 from '../error/Error404';
import LoadIndicator from '../../components/common/loading/LoadIndicator';
import styled from 'styled-components';

const Container = styled.div`
    padding: 1em 1.5em 2em;
    font-family: OpenSans, sans-serif;
    background: white;
    color: black;
    min-height: 50vh;

    .container {
        ${p => p.theme.breakpoints.up('lg')} {
            max-width: 1170px;
        }
    }

    h1 {
        text-transform: uppercase;
        font-size: 36px;
    }

    h2 {
        font-size: 30px;
    }

    h3 {
        font-size: 24px;
    }

    h1,
    h2,
    h3 {
        font-family: Brutal, Brutal_Medium, Arial, sans-serif;
        margin-top: 20px;
        margin-bottom: 10px;
        font-weight: 500;
        line-height: 1.1;
    }

    div,
    p,
    span {
        color: #4c4c4e;
        font-family: OpenSans, sans-serif;
        font-size: 14px;
    }

    p {
        margin: 0 0 10px;
    }

    i,
    cite,
    em,
    var,
    address,
    dfn {
        font-style: italic;
    }

    a {
        color: #0aaff1;
        text-decoration: none;
        transition: color ease-out 300ms;
        &:hover {
            color: #077aa8;
        }
        &:active,
        &:focus,
        &:hover,
        &:visited {
            text-decoration: none;
        }
    }
`;

const BlankContainer = ({pageData}) => {
    const isLoading = useLoading(pageData);
    const notFound = useNotFound(pageData);

    if (isLoading) {
        return <LoadIndicator fill />;
    }

    if (notFound) {
        return <Error404 />;
    }

    const content = pageData.content || '';

    return (
        <Container>
            {getHelmetForMetaTags(pageData)}
            <div className="container content">
                <div dangerouslySetInnerHTML={{__html: content}} />
            </div>
        </Container>
    );
};

BlankContainer.propTypes = {
    pageData: pt.object
};

export default BlankContainer;
